import { frontApiUrl } from '../../../../core/Api/Front/url';
import { Locale } from '../../../../core/i18n/Locale';
import { RegionsBoundariesSuccessResponseData } from '../../../../pages/api/front/regions/boundaries';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

async function fetchRegionBoundariesFromFront({
    locale,
    regionSlug,
}: {
    locale: Locale;
    regionSlug: string;
}) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_regions_boundaries', locale, {
                regionSlug,
                locale,
            }),
        ),
    );

    return handleResponse<RegionsBoundariesSuccessResponseData>(response);
}

export async function getRegionBoundariesFromFront({
    locale,
    regionSlug,
}: {
    locale: Locale;
    regionSlug: string;
}) {
    return fetchRegionBoundariesFromFront({
        locale,
        regionSlug,
    });
}
